import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { useAuthStore } from "../../../user/store/useAuthStore";
import { enum_api_uri } from "../utils/enum";

export interface CustomerData {
    customer_idx: number;
    customer_name: string;
    event_content_option: boolean;
    related_person_option: boolean;
    work_location_option: boolean;
    department_option: boolean;
    union_option: boolean;
    company_tel_option: boolean;
    wreath_sender_option: boolean;
    wreath_word_option: boolean;
    product_category: {
        product_category_idx: number;
        category_name: string;
        wreath_option: boolean;
        union_option: boolean;
    };
}

interface GetCustomerResponse {
    data: CustomerData;
}

export const useGetCommonTargetCustomer = (
    customer_idx: number,
    product_category_idx?: number,
): UseQueryResult<GetCustomerResponse, Error> => {
    const accessToken = useAuthStore(state => state.accessToken);
    const headers = {
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    };
    let url = enum_api_uri.common_get_target_customer.replace(":customer_idx", customer_idx?.toString());

    const params = []; // 쿼리 매개변수를 저장할 배열

    if (product_category_idx) {
        params.push(`product_category_idx=${product_category_idx}`);
    }

    // 쿼리 매개변수가 있는 경우 URL에 추가
    if (params.length > 0) {
        url += `?${params.join("&")}`;
    }

    return useQuery<GetCustomerResponse, Error>({
        queryKey: ["getCommonTargetCustomer", customer_idx, product_category_idx],
        queryFn: async () => {
            const response = await axios.get(url, accessToken ? { ...headers } : {});
            return response.data;
        },
        enabled: !!customer_idx,
    });
};
